import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex: 1;
  min-height: 423px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 30px;
  gap: 29px;

  font-size: 16px;
  line-height: 22px;
  text-align: center;
  font-weight: normal;

  .openTicket {
    font-weight: bold;
    color: var(--primary-color) !important;
  }

  color: #64728c;

  img {
    width: 125px;
  }

  b {
    color: var(--primary-color);
    cursor: pointer;
    text-decoration: underline;

    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }

  .schedules {
    b {
      cursor: auto;
      text-decoration: none;

      &:hover {
        filter: none;
      }
    }
  }
`;
